import styled from 'styled-components'

import { Typography, Wrapper } from '../../globals'

const StyledSortableHeader = styled.th<{ isLoading: boolean }>`
  font-size: 17px;
  cursor: ${({ isLoading }) => (isLoading ? 'not-allowed' : 'pointer')};
`

interface CustomColumnMeta {
  textAlign?: 'left' | 'center' | 'right'
}

type SortableHeaderProps = {
  key: string | number
  label: string
  onClick: (e: React.MouseEvent) => void
  columnId: string | undefined
  isLoading: boolean
  sort?: 'asc' | 'desc' | boolean
  meta?: CustomColumnMeta
}

const SortableTableHeader: React.FC<SortableHeaderProps> = (props) => {
  const { key, label, onClick, sort, columnId, meta, isLoading } = props
  return (
    <StyledSortableHeader isLoading={isLoading} onClick={isLoading ? undefined : onClick} key={key}>
      <Wrapper justifyContent={meta?.textAlign || 'left'} paddingLeft="16px" paddingRight="18px">
        <Wrapper width="auto">
          {label}
          {columnId !== 'select' && columnId !== 'action' && columnId !== 'documentType' && (
            <Wrapper display="box" marginLeft="0.5rem" cursor="pointer">
              <Typography fontSize="0.5rem" color={sort === 'asc' ? '#85f6f4' : undefined}>
                ▲
              </Typography>
              <Typography fontSize="0.5rem" color={sort === 'desc' ? '#85f6f4' : undefined}>
                ▼
              </Typography>
            </Wrapper>
          )}
        </Wrapper>
      </Wrapper>
    </StyledSortableHeader>
  )
}

export default SortableTableHeader
